export default __webpack_public_path__ + "static/media/mainLogo.2433f8c7.png";